import React from 'react';
import { Drawer, Form, Input, Select, Button, message, Upload } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './CreateTemplateDrawer.css';
import { templateService } from '../../../../api';

export default function CreateTemplateDrawer({ open, onClose, onCreate }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [fileList, setFileList] = React.useState([]);
  const [thumbnailBase64, setThumbnailBase64] = React.useState('');

  React.useEffect(() => {
    if (!open) {
      form.resetFields();
      setThumbnailBase64('');
      setFileList([]);
    }
  }, [open, form]);

  const handleUploadChange = ({ fileList: newFileList }) => {
    // Keep only the last file
    const latest = newFileList.slice(-1);
    setFileList(latest);
    const file = latest[0]?.originFileObj;
    if (!file) { setThumbnailBase64(''); return; }
    const reader = new FileReader();
    reader.onload = (e) => setThumbnailBase64(e.target.result);
    reader.readAsDataURL(file);
  };

  const beforeUpload = () => false; // prevent auto-upload

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      const payload = {
        name: values.name.trim(),
        milepadData: '{}',
        isActive: values.isActive === 'true' || values.isActive === true,
        sort: 0,
        thumbnail: thumbnailBase64 || 'string',
        docType: 'mileboard',
      };
      await templateService.createTemplate(payload);
      message.success('Template created successfully');
      onCreate?.();
      onClose();
    } catch (error) {
      if (error?.errorFields) return; // validation error, do nothing
      const msg = error?.response?.data?.message || 'Failed to create template';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const FooterBar = (
    <div className="ctd-bar">
      <Button
        type="primary"
        size="large"
        block
        className="ctd-create-btn"
        loading={loading}
        onClick={handleSubmit}
      >
        Create Template
      </Button>
    </div>
  );

  return (
    <Drawer
      className="ctd-drawer"
      title={<span style={{ fontWeight: 600, color: '#526bb1' }}>Create Template</span>}
      visible={open}
      onClose={onClose}
      width={640}
      destroyOnClose={false}
      styles={{ body: { background: '#f5f6f7', padding: 16 } }}
    >
      <div className="ctd" style={{ background: '#fff', borderRadius: 8, padding: '20px' }}>
        <Form form={form} layout="vertical" requiredMark={true} initialValues={{ isActive: 'true' }}>
          <Form.Item
            label={<span className="ctd-label">Name</span>}
            name="name"
            rules={[{ required: true, message: 'Enter template name' }]}
          >
            <Input placeholder="Enter template name" />
          </Form.Item>

          <Form.Item
            label={<span className="ctd-label">Active</span>}
            name="isActive"
            rules={[{ required: true, message: 'Select status' }]}
          >
            <Select placeholder="Select status">
              <Select.Option value="true">Active</Select.Option>
              <Select.Option value="false">Inactive</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item label={<span className="ctd-label">Thumbnail</span>}>
            <Upload
              accept="image/*"
              listType="picture"
              fileList={fileList}
              beforeUpload={beforeUpload}
              onChange={handleUploadChange}
              maxCount={1}
            >
              {fileList.length === 0 && (
                <div className="ctd-upload-placeholder"><PlusOutlined style={{ marginRight: 6, fontSize: 11 }} />Upload thumbnail image</div>
              )}
            </Upload>
          </Form.Item>
        </Form>

        <div style={{ paddingTop: 8 }}>
          {FooterBar}
        </div>
      </div>
    </Drawer>
  );
}
